import { render, staticRenderFns } from "./ServiceRecipe.vue?vue&type=template&id=88767008&scoped=true&"
import script from "./ServiceRecipe.vue?vue&type=script&lang=js&"
export * from "./ServiceRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88767008",
  null
  
)

export default component.exports